import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import Select from 'react-select'
import { connect } from 'react-redux'
import classNames from 'classnames'

import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import * as parameterActions from 'action/systemParameters'
import { bindActionCreators } from 'redux'

const ALL = 'all'

class RegionBranchMultipleSelect extends Component {
  static propTypes = {
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    showInternalServices: PropTypes.bool,
    translate: PropTypes.func.isRequired,
    user: PropTypes.object,
    value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    allOption: PropTypes.bool,
    className: PropTypes.string,
    userBranch: PropTypes.string,
    getParameterString: PropTypes.func,
    excludeInactive: PropTypes.bool

  }

  state = {
    options: [],
    error: null,
    loading: false,
    missionsSelectBranchs: []
  }

  getParameter(values) {
    const {user} = this.props
    return new Api(user.dsToken)
    .get(API_URL.PARAMETER_GET, values)
    .then(resp => {
      this.setState({missionsSelectBranchs: resp.data.split(",")})
    })
  }

  componentDidMount() {
    const params = {
      dsKey: "missions.select.branchs",
      nuParameter: 1
    }
    this.getParameter(params).finally(() => this.fetchData())
  }

  fetchData = async () => {
    const { user, excludeInactive } = this.props

    if (user) {
      this.setState({ loading: true })

      try {
        const endpoint = excludeInactive ? `${API_URL.BRANCHES}?excludeInactive=true` : API_URL.BRANCHES
        const { data } = await new Api(user.dsToken).post(endpoint)

        this.onFetchSuccess(data)
      } catch (error) {
        this.onFetchError(error)
      }
    }
  }

  onFetchSuccess = (companies) => {
    const { showInternalServices, translate, value, allOption, userBranch } =
      this.props

    const regionCompanies = companies.reduce((regionObj, company) => {
      const { idRegion } = company

      if (!regionObj[idRegion]) {
        const { dsRegion } = company

        regionObj[idRegion] = {
          branches: [],
          idRegion,
          dsRegion,
        }
      }

      regionObj[idRegion].branches.push(company)

      return regionObj
    }, {})

    const orderedRegionsIds = Object.keys(regionCompanies).sort(
      (idRegionA, idRegionB) => {
        const regionA = regionCompanies[idRegionA]
        const regionB = regionCompanies[idRegionB]

        if (regionA.dsRegion < regionB.dsRegion) return -1
        if (regionA.dsRegion > regionB.dsRegion) return 1
        return 0
      }
    )

    const newValue = [...value]

    const companyOptions = orderedRegionsIds.reduce((options, id) => {
      const { idRegion, dsRegion, branches } = regionCompanies[id]

      const isRegionSelected = newValue.some(
        (selected) => selected.value === idRegion
      )

      options.push({
        value: idRegion,
        label: dsRegion,
        visible: !isRegionSelected,
        disabled: isRegionSelected,
        idBranches: companies.reduce((acc, cur) => {
          if (cur.idRegion === idRegion) {
            return [...acc, cur.id]
          }

          return acc
        }, []),
      })

      branches.forEach((branch) => {
        const matchIndex = newValue.findIndex(
          (selected) => selected.value === branch.id
        )

        // Ensures that each branch populates with idRegion
        if (matchIndex > -1) {
          newValue[matchIndex] = {
            ...value[matchIndex],
            idRegion: branch.idRegion,
          }
        }

        options.push({
          value: branch.id,
          label: `${branch.id} - ${branch.name}`,
          isBranch: true,
          idRegion: branch.idRegion,
          visible: !isRegionSelected,
          disabled: isRegionSelected,
        })
      })

      return options
    }, [])

    if (showInternalServices) {
      companyOptions.push({
        value: 999,
        label: `0999 - ${translate('analytics.matrix.name')}`,
        isBranch: true,
        isBold: true,
        visible: true,
      })
    }

    if (allOption) {
      companyOptions.unshift({
        value: ALL,
        label: translate('option.all'),
        visible: true,
      })
    }

    this.setState({ options: companyOptions, loading: false, error: null })
    // Update values with the udpated ones
    if (newValue && newValue.length > 0) {
      this.handleChange(newValue)
    }

    
    const hasBranchSelectPermission = this.state.missionsSelectBranchs.includes(this.props.user.title)
    
    if (userBranch !== undefined && userBranch !== '999') {
      if (!hasBranchSelectPermission) {
        const determinedBranch = companyOptions.filter(
          (option) => option.value === userBranch.padStart(4, '0')
        )
        this.handleChange(determinedBranch)
      }
    }
  }

  onFetchError = (error) => {
    this.setState({ error, loading: false, options: [] })
  }

  onChange = (values) => {
    const { options } = this.state

    const parsedOptions = options.map((option) => ({
      ...option,
      visible: true,
      disabled: false,
    }))

    values = values || []

    const regionsSelected = values.filter((item) => !item.isBranch)

    const selectedValues = values.reduce((valuesList, item) => {
      if (!item.isBranch) {
        parsedOptions
          .filter((branchItem) => branchItem.idRegion === item.value)
          .forEach((option) => {
            option.visible = false
            option.disabled = true
          })

        valuesList.push(item)
      } else {
        if (
          !regionsSelected.find(
            (regionItem) => regionItem.value === item.idRegion
          )
        ) {
          valuesList.push(item)
        }
      }

      return valuesList
    }, [])

    this.setState({ options: parsedOptions })
    this.handleChange(selectedValues)
  }

  handleChange = (value) => {
    const { onChange, name } = this.props

    const { options } = this.state

    let event = { target: { name, value } }

    if (value.some((option) => option.value === ALL)) {
      const newValue = options.filter(
        (option) => option.isBranch || option.value === ALL
      )
      event = { target: { name, value: newValue } }
    }

    if (onChange) {
      onChange(event)
    }
  }

  filterOptions = (option, inputValue) => {
    inputValue = inputValue.toLowerCase()
    const lcLabel = option.label.toLowerCase()

    const matches = lcLabel.includes(inputValue)

    return matches && option.data.visible
  }

  renderOption = (option) => {
    const isBranchAndNotBold = option.isBranch && !option.isBold

    const className = classNames(
      { 'option-branch': isBranchAndNotBold },
      { 'option-region': !isBranchAndNotBold },
      { hidden: !option.visible }
    )

    return (
      <option value={option.value} className={className}>
        {option.label}
      </option>
    )
  }

  render() {
    const { className, ...props } = this.props
    const { options, loading } = this.state

    const placeholder = loading ? props.translate('loading') : props.placeholder

    return (
      <Select
        {...props}
        isMulti
        closeMenuOnSelect={false}
        className={`react-select react-select-multi ${className}`}
        classNamePrefix={'react-select'}
        placeholder={placeholder}
        options={options}
        onChange={this.onChange}
        filterOption={(option, inputValue) =>
          this.filterOptions(option, inputValue)
        }
      />
    )
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...parameterActions }, dispatch)

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
})

/*
 * Connects component to I18next
 */
const RegionBranchMultipleSelectTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(RegionBranchMultipleSelect)

/*
 * Exports component connected to redux
 */
export default connect(mapStateToProps, mapDispatchToProps)(RegionBranchMultipleSelectTranslated)

/*
 * Exports component only
 */
export { RegionBranchMultipleSelect }
